import axios from "axios";
import { replaceOrderIdInIntegrationUrl } from "../utils/externalIntegration";

/** No app JWT — third-party GET only from the browser (CORS must allow your portal origin). PDF uploads go through the portal API (`ExternalIntegrationModel.execute`). */
const externalHttp = axios.create({
  timeout: 120000,
});

/**
 * GET configured fetch URL with {ORDER_ID} (or legacy {{ORDER_ID}}) replaced.
 * @param {object} integration - saved row with url, headers
 * @param {string|number} externalOrderId - value substituted for the placeholder
 */
export async function fetchExternalOrderByIntegration(
  integration,
  externalOrderId
) {
  const url = replaceOrderIdInIntegrationUrl(integration.url, externalOrderId);
  const headers = { ...(integration.headers || {}) };
  const { data } = await externalHttp.get(url, { headers });
  return data;
}
